export const N09 = {
  columns: 12,
  rows: 2,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Sessions Raw Data",
    binding: {
      data: {
        columns: [
              {
                name: "Session Number",
                columnName: "SessionNumber",
                width: "160px",
                align: "left",
                sortable: false,
              },
              {
                name: "Agent Code",
                columnName: "AgentCode",
                width: "160px",
                align: "left",
                sortable: true,
              },
              {
                name: "Employee Name",
                columnName: "EmployeeName",
                width: "220px",
                align: "left",
                sortable: true,
              },
              { 
                name: "Cycle Code",
                columnName: "CycleCode",
                width: "140px",
                align: "center",
                sortable: true,
              },
              {
                name: "Cycle Description",
                columnName: "CycleDescription",
                width: "180px",
                align: "left",
                sortable: true,
              },
              {
                name: "Week",
                columnName: "WEEK",
                width: "100px",
                align: "center",
                sortable: true,
              },
              {
                name: "Start Date",
                columnName: "StartDate",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "End Date",
                columnName: "EndDate",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Session Date",
                columnName: "SessionDate",
                width: "150px",
                align: "center",
                sortable: true,
              },
              {
                name: "Call Type",
                columnName: "CallType",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "New Institution Name",
                columnName: "NewInstitutionName",
                width: "250px",
                align: "left",
                sortable: true,
              },
              {
                name: "New Institution Address",
                columnName: "NewInstitutionAddress",
                width: "400px",
                align: "left",
                sortable: true,
              },
              {
                name: "New Institution Remarks",
                columnName: "NewInstitutionRemarks",
                width: "400px",
                align: "left",
                sortable: true,
              },
              {
                name: "New Customer Name",
                columnName: "NewCustomerName",
                width: "250px",
                align: "left",
                sortable: true,
              },
              {
                name: "Account Code",
                columnName: "AccountCode",
                width: "160px",
                align: "left",
                sortable: true,
              },
              {
                name: "Account Name",
                columnName: "AccountName",
                width: "370px",
                align: "left",
                sortable: true,
              },
              {
                name: "Device ID",
                columnName: "ActualDeviceID",
                width: "240px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Start Date",
                columnName: "ActualStartDate",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Start Time",
                columnName: "ActualStartTime",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Location Lat",
                columnName: "ActualLocationLat",
                width: "200px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Location Long",
                columnName: "ActualLocationLong",
                width: "200px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual Location Text",
                columnName: "ActualLocationText",
                width: "400px",
                align: "left",
                sortable: true,
              },
              {
                name: "Actual End Date",
                columnName: "ActualEndDate",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual End Time",
                columnName: "ActualEndTime",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual End Location Lat",
                columnName: "ActualEndLocationLat",
                width: "220px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual End Location Long",
                columnName: "ActualEndLocationLong",
                width: "220px",
                align: "center",
                sortable: true,
              },
              {
                name: "Actual End Location Text",
                columnName: "ActualEndLocationText",
                width: "400px",
                align: "left",
                sortable: true,
              },
              {
                name: "Duration",
                columnName: "Duration",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Reason Code",
                columnName: "ReasonCode",
                width: "170px",
                align: "center",
                sortable: true,
              },
              {
                name: "Reason Description",
                columnName: "ReasonDescription",
                width: "200px",
                align: "center",
                sortable: true,
              },
              {
                name: "Remarks",
                columnName: "Remarks",
                width: "170px",
                align: "center",
                sortable: true,
              },
        ],
        title: "EmployeeName",
        onLoad: "Pgn.N09",
        subtotal: true,
        pagination: {
          show: true
        },
        endpoint: "N09",
        parameters: [
          { key: "FromMonth", value: "CP1" },
          { key: "FromYear", value: "2026" },
          { key: "ToMonth", value: "CP1" },
          { key: "ToYear", value: "2026" },
          { key: "PageIndex", value: "1" },
          { key: "ResultsPerPage", value: "10" },
        ],
      },
      context: {
        point: {
          onClick: {},
        },
      },
    },
  },
};
